// KPI tile, mirrors the priority-risk.html .kpi pattern
import { TID } from "@/lib/testIds";

export default function KpiCard({ icon: Icon, label, value, tone = "neutral", trend, kpiKey }) {
    const tones = {
        accent: { bg: "#FBEFE5", fg: "#9F4212" },
        green: { bg: "#E8F1E6", fg: "#3F7D3A" },
        amber: { bg: "#FCF1DC", fg: "#C68A1C" },
        red: { bg: "#FBE8E5", fg: "#B33A2E" },
        blue: { bg: "#E7EEF9", fg: "#2A5DB0" },
        purple: { bg: "#EEE9F6", fg: "#6B4E9E" },
        neutral: { bg: "#F0EDE8", fg: "#6F6A64" },
    };
    const t = tones[tone] || tones.neutral;
    return (
        <div
            data-testid={kpiKey ? TID.kpi(kpiKey) : undefined}
            className="bg-white border border-brand-line rounded-[11px] p-4 transition-all hover:shadow-brand hover:-translate-y-px"
            style={{ borderColor: "#E5E0DA" }}
        >
            <div className="flex items-center justify-between mb-3">
                <div
                    className="w-[34px] h-[34px] rounded-[9px] grid place-items-center"
                    style={{ background: t.bg, color: t.fg }}
                >
                    {Icon ? <Icon className="w-[17px] h-[17px]" /> : null}
                </div>
                {trend ? (
                    <span className="text-[10.5px] font-semibold" style={{ color: trend.color || "#6F6A64" }}>
                        {trend.label}
                    </span>
                ) : null}
            </div>
            <div className="font-display font-bold text-[28px] leading-none tracking-tight text-[#1F1F1F]">
                {value}
            </div>
            <div className="text-[11.5px] mt-1.5 font-medium" style={{ color: "#6F6A64" }}>
                {label}
            </div>
        </div>
    );
}
